import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds
});

// Contact Form API
export const submitContactForm = async (formData) => {
  try {
    const response = await apiClient.post('/contact', formData);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    
    if (error.response) {
      // Server responded with error
      return {
        success: false,
        error: error.response.data.error || 'Error al enviar el mensaje'
      };
    } else if (error.request) {
      // Request made but no response
      return {
        success: false,
        error: 'No se pudo conectar con el servidor. Intenta nuevamente.'
      };
    } else {
      // Other errors
      return {
        success: false,
        error: 'Error al procesar tu solicitud'
      };
    }
  }
};

export default apiClient;
